import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import {
  Box,
  PaymentSummary,
  SummaryDescription,
  TextDescription,
  Wrapper,
  SectionTitle,
  OperationType,
  Separator
} from './styled';
import { PrintDetail } from '@app/src/views/StepThree/publicationConfirmation/components/PrintDetail';
import { PrintDetailShimmer } from '@app/src/views/StepThree/publicationConfirmation/components/PrintDetailShimmer';
import { ModalErrorFeature } from '@app/src/common/modalError';
import { setPrintData } from '@app/src/views/StepTwo/channelPublication';
import { Disclaimer } from '@app/src/common/Disclaimer';
import { fetchSummary, fetchSummaryConsume } from '@app/src/views/StepThree/publicationConfirmation/state/summary/actions';
import { isClientEnv } from '@app/src/utils/validations';
import { CATEGORIES } from '@app/src/config/categories';
import { Title } from '@app/src/common/Title';
import { FormActions } from '@app/src/views/StepThree/publicationConfirmation/components/FormActions';

const isClient = isClientEnv();

export const PublicationConfirmation: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { idPrint, packageId } = useParams();
  const isFetching = useSelector(state => state.summary.isFetching);
  const { print, price, extra } = useSelector(state => state.summary.data);
  const printData = isClient && JSON.parse(sessionStorage.getItem('print'));
  const getAliasCategory = () => location.pathname.split('-')[2];
  const categoryConfig = CATEGORIES[getAliasCategory()];
  const typeUserAction = useSelector(state => state.session.user.pasarella);
  const userStorage = isClient && JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    if (printData && printData.general && categoryConfig && printData.general.category === categoryConfig.id && idPrint) {
      dispatch(setPrintData(printData));
      if (typeUserAction === 'consume-print') {
        const userId = userStorage && userStorage.data && userStorage.data.id;
        dispatch(fetchSummaryConsume(userId, printData.general.category, idPrint));
      }
      if (typeUserAction === 'purchase-print') {
        dispatch(fetchSummary(printData.general.category, idPrint));
      }
    } else {
      if (typeUserAction === 'purchase-package') {
        history.push(`${categoryConfig.paths.consumePackage.stepTypePublication}/${packageId}`);
      }
      if (typeUserAction === 'purchase-print') {
        history.push(categoryConfig.paths.purchasePrint.stepTypePublication);
      }
    }
  }, [typeUserAction]);

  useEffect(() => {
    if (!print) {
      if (typeUserAction === 'consume-print') {
        history.push(`${categoryConfig.paths.consumePackage.stepTypePublication}/${packageId}`);
      }
      if (typeUserAction === 'purchase-print') {
        history.push(categoryConfig.paths.purchasePrint.stepTypePublication);
      }
    }
  }, [print]);

  if (isFetching) {
    return (
      <React.Fragment>
        <PrintDetailShimmer />
        <ModalErrorFeature />
      </React.Fragment>
    )
  }

  return (
    <Wrapper>
      <Title>Confirmar publicación</Title>
      {
        extra && extra.section ?
          <React.Fragment>
            <SectionTitle color={'#f0f0f0'}>
              {extra && extra.section} - <OperationType>{extra && extra.operationType}</OperationType>
            </SectionTitle>
            <Separator />
          </React.Fragment> : null
      }
      {print.map((print, index) => (
        <PrintDetail key={index} detail={print} />
      ))}
      {
        typeUserAction === 'purchase-print' &&
        <Box>
          <PaymentSummary color={'#f0f0f0'}>
            {
              print && print.length > 1 ?
                <SummaryDescription>
                  <TextDescription>Sub Total</TextDescription>
                  <TextDescription>{price && `S/ ${price.subTotal}`}</TextDescription>
                </SummaryDescription> : null
            }
            {price && price.discount ?
              <SummaryDescription>
                <TextDescription>Descuento ({price && price.discount}%)</TextDescription>
                <TextDescription>{price && `S/ ${price.totalDiscount}`}</TextDescription>
              </SummaryDescription> : null
            }
            <SummaryDescription>
              <TextDescription>IGV ({price && price.igv}%)</TextDescription>
              <TextDescription>{price && `S/ ${price.totalIgv}`}</TextDescription>
            </SummaryDescription>
            <SummaryDescription>
              <TextDescription isBold>Total a pagar (Inc. IGV.)</TextDescription>
              <TextDescription isBold>{price && `S/ ${price.total}`}</TextDescription>
            </SummaryDescription>
          </PaymentSummary>
        </Box>
      }
      <Disclaimer />
      <FormActions
        priceTotal={typeUserAction === 'purchase-print' && price && Number(price.total)}
        categoryConfig={categoryConfig} />
    </Wrapper>
  );
};

PublicationConfirmation.displayName = 'PublicationConfirmation';
